export default __webpack_public_path__ + "static/certificate-hipaa-4679d15085e531147bc44fcf79faa3bd.svg";